
const newModel = () => {
    return {
        thethaoPhamviId: null,
        ten: null,
        quocTe: null,
        moTa: null,
        ghiChu: null,
        stt: null,
        enabled: null,

        dateCreated: null,
        userCreated: null,
        dateModified: null,
        userModified: null,
        isDeleted: null,
        userDeleted: null,
        dateDeleted: null,
        tenUserCreated: null,
        tenUserModified: null,
        tenUserDeleted: null
    }
}

const newFEModel = () => {
    return {
        thethaoPhamviId: null,
        ten: null,
        quocTe: null,
        moTa: null,
        ghiChu: null,
        stt: "0",
        enabled: true,
    }
}

const fromJson = (item) => {
    return {
        thethaoPhamviId: item.thethaoPhamviId,
        ten: item.ten,
        quocTe: item.quocTe,
        moTa: item.moTa,
        ghiChu: item.ghiChu,
        stt: item.stt,
        enabled: item.enabled,
    }
}

const parseModeltoFEModel = (item) => {
    return {
        thethaoPhamviId: item.thethaoPhamviId,
        ten: item.ten,
        quocTe: item.quocTe,
        moTa: item.moTa,
        ghiChu: item.ghiChu,
        stt: item.stt,
        enabled: item.enabled,
    }
}

const newPagingSearchModel = () => {
    return {
        thethaoBomonId: null,
        ten: null,
        moTa: null,
        ghiChu: null,
        enabled: null,
    }

}

const errors = () => {
    return {
        thethaoPhamviId: null,
        ten: null,
        quocTe: null,
        moTa: null,
        ghiChu: null,
        stt: null,
        enabled: null,
    }
}

export const phamViGiaiTheThaoVHModel = {
    newModel,
    newFEModel,
    parseModeltoFEModel,
    newPagingSearchModel,
    fromJson,
    errors,
}


